export const OTS_CLICKED_GUEST_VIEW = "OTS: CLICKED GUEST VIEW BUTTON";
export const OTS_REQUEST_ACCESS = "OTS: REQUEST ACCESS";
export const DOOR_UNIT_CHANGED = "DOOR: UNITS CHANGED";
export const GRID_CELL_CHANGE = "GRID: CELL CHANGE";
export const CDP_CELL_CHANGE = "CDP: CELL CHANGE";
export const EXPORT_ASSORTMENT = "EXPORT: ASSORTMENT";
export const EXPORT_ROLLUP = "EXPORT: ROLLUP";
export const EXPORT_ASSORTMENT_TO_MERCHANT = "EXPORT: ASSORTMENT TO MERCHANT";
export const SHIPMENT_REVIEW_TAB_CLICKED = "SHIPMENT_REVIEW: TAB CLICKED";
export const SHIPMENT_REVIEW_TILE_VIEW_CLICKED = "SHIPMENT_REVIEW_TILE_VIEW: TAB CLICKED";
export const SHIPMENT_REVIEW_GRID_VIEW_CLICKED = "SHIPMENT_REVIEW_GRID_VIEW: TAB CLICKED";
export const ITEM_VIEW_TYPE_LARGE_TILE_CLICKED = "ITEM_VIEW_TYPE: LARGE TILE VIEW CLICKED";

export enum BuildOrderActions {
    OrderSetupBtn = "BO: ORDER SETUP BUTTON CLICKED",
    CalendarBtn = "BO: CALENDAR BUTTON CLICKED",
    isActive = "BO: AT LEAST ONE SHIP DATE SETUP",
    WODateOrganizerProductEntrySelected = "BO: WO DATE ORGANIZER INDIVIDUAL PRODUCT ENTRY POINT SELECTED",
    WODateOrganizerProductBuyer = "BO: WO DATE ORGANIZER SELECTED MOVE/DUPLICATE PRODUCT INTO SHIP DATE",
    WODateOrganizerProductMultiple = "BO: WO DATE ORGANIZER SELECTED MORE THAN ONE SHIPMENT",
    WODateOrganizerBulkShipmentSelected = "BO: WO BULK SHIPMENT ENTRY POINT SELECTED",
    WODateOrganizerBulkShipmentAction = "BO: WO BULK SHIPMENT ACTION SELECTED",
    WODateOrganizerBulkShipmentIgnoreUnits = "BO: WO BULK SHIPMENT IGNORE UNITS CHECKED",
    WODateOrganizerBulkShipmentDuplicatedDates = "BO: WO BULK SHIPMENT MOVE/DUPLICATE PRODUCT INTO SHIP DATE",
}

// Site analytics
export enum SiteActions {
    Search = "SITE: SEARCH",
    SearchSuggestionClicked = "SITE: SEARCH SUGGESTION CLICKED",
    CategoryClicked = "SITE: CATEGORY CLICKED",
}

export enum LoginActions {
    LoginArticles = "LOGIN: ARTICLES",
    LoginRegistration = "LOGIN: REGISTRATION",
    LoginVideo = "LOGIN: VIDEO",
}

export enum AssortmentShoppingActions {
    AddProduct = "ASSORTMENT SHOPPING: ADD PRODUCT",
    AddAllProducts = "ASSORTMENT SHOPPING: ADD ALL PRODUCTS",
    SmuAdded = "ASSORTMENT SHOPPING: SMU ADDED",
    SmuCloned = "ASSORTMENT SHOPPING: SMU CLONED",
}

export enum AssortmentActions {
    CreateAssortment = "Create Assortment",
    ShareAssortment = "Share Assortment",
    ViewAssortment = "View Assortment",
    ViewRollUp = "View RollUp",
    CopyAssortment = "COPY ASSORTMENT",
}

export enum SavedViewsActions {
    Promote = "SAVED_VIEWS: PROMOTE",
    Create = "SAVED_VIEWS: CREATE",
    MerchantUpdate = "MERCHANT_SAVED_VIEWS: UPDATE",
    MerchantUpdateLocal = "MERCHANT_SAVED_VIEWS_LOCAL: UPDATE",
    MerchantDelete = "MERCHANT_SAVED_VIEWS: DELETE",
    Update = "SAVED_VIEWS: UPDATE",
    Open = "SAVED_VIEWS: OPEN",
    Reset = "SAVED_VIEWS: RESET",
    Remove = "SAVED_VIEWS: REMOVE",
}

export enum SizeActions {
    FindSizeClicked = "SIZE: FIND SIZE SEARCH CLICKED",
    ApplySizeCurve = "SIZE: APPLY SIZE CURVE CLICKED",
    SizeUnitsChanged = "SIZE: UNITS CHANGED",
}

export enum Location {
    Cdp = "CDP",
    Grid = "GRID",
}

export enum ExportItemPo {
    CreateExportItemPo = "CREATE EXPORT ITEM/PO",
    ValidateItemData = "EXPORT_ITEMS_PO: VALIDATE ITEM DATA",
    ValidatePoData = "EXPORT_ITEMS_PO: VALIDATE PO DATA",
    DownloadExport = "EXPORT_ITEMS_PO: DOWNLOAD ERRORS",
}

export enum Feedback {
    ProductClick = "FEEDBACK: CLICKED ON PRODUCT",
    Search = "FEEDBACK: SEARCHED IN FEEDBACK PANEL",
    Toggle = "FEEDBACK: TOGGLED FILTER GRID",
}

export enum AssortmentInventoryActions {
    SyncInventoryUnits = "SYNC INVENTORY UNITS",
}

export enum AllocationDimensionClipboardActions {
    cut = "ALLOCATION_DIMENSION_UNITS: CUT",
    copy = "ALLOCATION_DIMENSION_UNITS: COPY",
}

export enum BrandAdminDataflowSyncActions {
    reprocess = "BRAND_ADMIN_DATAFLOW_SYNC: REPROCESS",
}

export enum InsightsActions {
    tabClick = "ORDER_INSIGHTS_TAB_CLICK",
    openDrawerGallery = "ORDER_INSIGHTS_DRAWER_OPENED_GALLERY",
    openDrawerCart = "ORDER_INSIGHTS_DRAWER_OPENED_CART",
    addProductToCartClick = "ORDER_INSIGHTS_ADD_PRODUCT_TO_CART_CLICK",
    helpdeskClick = "ORDER_INSIGHTS_HELPDESK_CLICK",
    productClick = "ORDER_INSIGHTS_PRODUCT_CLICK",
    drawerScroll = "ORDER_INSIGHTS_DRAWER_SCROLL",
    selectedImmediateProductInsights = "ORDER_INSIGHTS_SELECTED_IMMEDIATE_PRODUCTS_CLICK",
    selectedPrebookProductInsights = "ORDER_INSIGHTS_SELECTED_PREBOOK_PRODUCTS_CLICK",
    selectProductTypeClick = "ORDER_INSIGHTS_SELECT_PRODUCT_TYPE_CLICK",
}
